import { createSelector } from "reselect";
export const selectAuth = state => state.auth || {};
export const currentClientSelector = state => state.currentClient || {};
export const tokenSelector = createSelector(
  [selectAuth],
  (auth = {}) => {
    return auth.token;
  }
);



// WEBPACK FOOTER //
// src/redux/selectors/auth.js